export default {
    init() {
        const target = document.querySelectorAll('[data-ispot=accordian]');
        target.forEach((item) => {
            this.bindEvent(item);
        });
    },
    bindEvent(item) {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const className = 'active';
            const parent = e.target.parentNode;
            const parentClass = parent.classList;
            if (parentClass.contains(className)) {
                parentClass.remove(className);
            } else {
                const siblings = [...parent.parentNode.children];
                siblings.forEach((el) => {
                    el.classList.remove(className);
                });
                parentClass.add(className);
            }
        });
    },
};
